import { CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE } from './../const';

function action(token, lang, successCallback, errorCallback) {
  return { type: CUSTOMER_JOURNEY_MAIL_UNSUBSCRIBE, token, lang, successCallback, errorCallback };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyMailUnsubscribe.js